import locale from "localization";
import Path from "./path";
import PagesKeys from "./pages-key";
import Role from "./role";
import { StationsIcon, PromoIcon, ProductsIcon, Records } from "images";
import RolePermissions from "./role-permissions";

let Navigation = [
  {
    label: locale.stations,
    link: Path.Stations,
    icon: StationsIcon,
    exact: true,
    key: PagesKeys.STATIONS,
    permission: [
      {
        role: Role.PortalAdmin,
        fullAccess: true,
      },
      {
        role: Role.Marketing,
        fullAccess: true,
      },
      {
        role: Role.Dealer,
        ...RolePermissions,
        modifyAccess: false,
        addAccess: false,
      },
    ],
  },
  {
    label: locale.promos,
    link: Path.PromosList,
    icon: PromoIcon,
    exact: true,
    key: PagesKeys.PROMO,
    permission: [
      {
        role: Role.PortalAdmin,
        fullAccess: true,
      },
      {
        role: Role.Marketing,
        fullAccess: true,
      },
      {
        role: Role.Dealer,
        fullAccess: true,
      },
    ],
  },
  {
    label: locale.products,
    link: Path.Products,
    icon: ProductsIcon,
    exact: true,
    key: PagesKeys.PRODUCTS,
    permission: [
      {
        role: Role.PortalAdmin,
        fullAccess: true,
      },
      {
        role: Role.Marketing,
        fullAccess: true,
      },
      {
        role: Role.Dealer,
        ...RolePermissions,
        addAccess: false,
        modifyAccess: false,
        voidAccess: false,
      },
    ],
  },
  // {
  //   label: locale.inventory,
  //   link: Path.Inventory,
  //   icon: Inventory,
  //   expanded: true,
  //   items: [
  //     {
  //       label: locale.orderSummary,
  //       child: true,
  //       link: Path.OrderSummary,
  //       key: PagesKeys.ORDER_SUMMARY,
  //     },
  //   ],
  //   permission: [
  //     {
  //       role: Role.PortalAdmin,
  //       fullAccess: true,
  //     },
  //     {
  //       role: Role.Marketing,
  //       fullAccess: true,
  //     },
  //     {
  //       role: Role.Dealer,
  //       fullAccess: true,
  //     },
  //   ],
  // },
  {
    label: locale.records,
    link: Path.Records,
    icon: Records,
    expanded: true,
    items: [
      {
        label: locale.shiftRecords,
        child: true,
        link: Path.ShiftRecords,
        key: PagesKeys.SHIFT_RECORDS,
      },
      {
        label: locale.discountReport,
        child: true,
        link: Path.DiscountReport,
        key: PagesKeys.DISCOUNT_REPORT,
      },
    ],
    permission: [
      {
        role: Role.PortalAdmin,
        fullAccess: true,
      },
      {
        role: Role.Dealer,
        ...RolePermissions,
        addAccess: false,
        modifyAccess: false,
        voidAccess: false,
      },
    ],
  },
];

export default Navigation;
